// Reusable autocomplete component for Alpine.js
window.AutocompleteComponent = {
  create: function(config) {
    return {
      inputValue: config.initialValue || '',
      selectedValue: config.initialValue || '',
      options: config.options || [],
      filteredOptions: [],
      isOpen: false,
      highlightedIndex: -1,
      blurTimer: null,
      inputRef: null,
      
      init() {
        this.inputRef = this.$el.querySelector('.autocomplete-input');
        this.filteredOptions = this.options;
        if (config.onInit) config.onInit.call(this);
      },
      
      filterOptions() {
        const query = this.inputValue.toLowerCase().trim();
        this.filteredOptions = query ? 
          this.options.filter(option => 
            option.name.toLowerCase().includes(query) ||
            option.code?.toLowerCase().includes(query)
          ) : this.options;
        this.highlightedIndex = -1;
        this.isOpen = this.filteredOptions.length > 0;
      },
      
      selectOption(option) {
        this.selectedValue = option.name;
        this.inputValue = option.name;
        this.isOpen = false;
        this.highlightedIndex = -1;
        
        if (config.onSelect) config.onSelect.call(this, option);
      },
      
      handleKeydown(event) {
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault();
            this.highlightedIndex = Math.min(this.highlightedIndex + 1, this.filteredOptions.length - 1);
            break;
          case 'ArrowUp':
            event.preventDefault();
            this.highlightedIndex = Math.max(this.highlightedIndex - 1, -1);
            break;
          case 'Enter':
            event.preventDefault();
            if (this.highlightedIndex >= 0) {
              this.selectOption(this.filteredOptions[this.highlightedIndex]);
            }
            break;
          case 'Escape':
            this.isOpen = false;
            this.highlightedIndex = -1;
            break;
        }
      },
      
      handleBlur() {
        this.blurTimer = setTimeout(() => {
          this.isOpen = false;
          if (config.onBlur) config.onBlur.call(this);
        }, window.ValidationUtils.constants.BLUR_DELAY);
      },
      
      handleFocus() {
        if (this.blurTimer) {
          clearTimeout(this.blurTimer);
          this.blurTimer = null;
        }
        this.filterOptions();
      },
      
      destroy() {
        if (this.blurTimer) {
          clearTimeout(this.blurTimer);
          this.blurTimer = null;
        }
        if (config.onDestroy) config.onDestroy.call(this);
      }
    };
  }
};